<div class="row">
  <div class="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 text-center">

    <div class="card">
      <div class="content">
        <img class="intergration-installed-image" src="/assets/img/Work_Anniversary.svg" />
        <p class="intergration-installed-text">Slack integration successfully installed</p>
      </div>
    </div>

  </div>
</div>
